import './instagram_message_builder.js.coffee'
import '../instagram_message_text.js.coffee'
Namespace 'Models.Builders'

class Models.Builders.InstagramMessageTextBuilder extends Models.Builders.InstagramMessageBuilder
  constructor: ->
    super()
    @messageText = null

  build: ->
    new Models.InstagramMessageText(@)
